<template>
  <b-button
    v-if="hasDocuments"
    size="md"
    variant="link"
    :style="{ backgroundColor: '#08A762', color: '#ffffff' }"
    class="ml-3"
    @click="documentsDownload"
  >
    <i class="fa fa-download" />
    Download documents
  </b-button>
</template>

<script lang="ts">
import { defineComponent, computed, type ComputedRef } from 'vue'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'

export default defineComponent({
  name: 'DownloadDocuments',
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const documentsUrl: ComputedRef<string | null> = computed(() => assignmentSummaryStore.documentsUrl)
    const hasDocuments = computed(() => !!documentsUrl.value)

    const documentsDownload = () => {
      const url = documentsUrl.value
      if (url) {
        window.open(url, '_blank')
      }
    }

    return {
      hasDocuments,
      documentsDownload,
    }
  },
})
</script>
